export default {
    vinSizeIsValid: (year, vin, minSize, maxSize) => {
        if (
            vin.toString().length !== 0 &&
            year >= 1981 &&
            (vin.toString().length < minSize || vin.toString().length > maxSize)
        ) {
            return false;
        }
        return true;
    },
};
